export enum Variants {
  IFRAME = 'iframe',
  NEW_TAB = 'new-tab',
  SAME_TAB = 'same-tab'
}
